// extracted by mini-css-extract-plugin
module.exports = {"container":"searchResults_container__13oVc","search_subtitle":"searchResults_search_subtitle__2NGfT"};